import React, { useEffect } from 'react';
import { Form } from 'antd';
import FormCard from 'pages/NewUniProfile/components/FormCard';
import DatesOverride from 'components/Calendar/DatesOverride';
import commonS from '../../s.module.less'
import s from './s.module.less';
import { IproviderOverrideList, TimeItemType } from 'types/appointmentSetting';
import { getOverrideDate, transferTimePicker, mergeOverrideList } from 'components/Calendar/DatesOverride/utils';

interface Props {
    initValue?: IproviderOverrideList[] | null;
    onSave?: () => void;
}

const DateTimeOverride: React.FC<Props> = (props) => {
    const { initValue, onSave } = props;
    const [form] = Form.useForm();

    useEffect(() => {
        if (initValue) {
            form.setFieldsValue(initValue);
        }
    }, [initValue, form]);

    const handleSave = async () => {
        try {
            const values = await form.validateFields();
            console.log('Date time override values:', values);
            onSave?.();
        } catch (error) {
            console.error('Form save failed:', error);
        }
    };

    const renderEditing = () => {
        return (
            <div className={commonS.displayItem}>
                <div className={commonS.label}>Override</div>
                <DatesOverride />
            </div>
        );
    };

    const renderReview = () => {
        if (!initValue?.length) {
            return (
                <div>
                    Not provided
                </div>
            );
        }

        const overrideList = mergeOverrideList(initValue);

        return (
            <div className={commonS.displayItem}>
                <div className={commonS.label}>Override</div>
                <div className={s.overridesList}>
                    {overrideList.map((override, index) => {
                        const timeArr = override?.time;
                        return (
                            <div key={index} className='flex'>
                                <div className={s.overrideItem} style={{ width: '180px' }}>
                                    {
                                        typeof getOverrideDate(override) === 'string' ? <span className={commonS.value}>{getOverrideDate(override)}</span> : (getOverrideDate(override) as string[]).map((date) => {
                                            return <span className={commonS.value} key={date}>{date}</span>;
                                        })
                                    }
                                </div>
                                <div className={s.overrideItem}>
                                    {
                                        timeArr && timeArr?.map((i: TimeItemType, idx: number) => {
                                            return <span className={commonS.value} key={idx}>{transferTimePicker(i)}</span>;
                                        })
                                    }
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        );
    };

    return (
        <FormCard type='review' title='Date & time override' hasContent={true} onSave={handleSave}>
            {(isEditing) => isEditing ? renderEditing() : renderReview()}
        </FormCard>
    );
};

export default DateTimeOverride;